import { useRouter } from "next/router";
import { titleHowToBooking } from "../../src/components/MockData/MockData";
import ClientLayout from "../../src/layouts/client/ClientLayout"
import MetaHeader from "../../src/components/MetaHeader";
import { textConfig } from "../../constants/textLang";

const HowToBooking = () => {
    const router = useRouter()
    const { locale } = router
    return (
        <ClientLayout style={{ backgroundColor: 'black' }}>
            <section className="cookie-policy">
                <div className="content-footer-wrapper">
                    <div className="header-title">
                        <h1>{titleHowToBooking[locale].head_title}</h1>
                    </div>
                    <ol className="main-content-text">
                        <li>
                            <p>{titleHowToBooking[locale].head_text_content}</p>
                            {titleHowToBooking[locale].topic_content.map((item, index) => (
                                <><p style={{ marginTop: "2rem" }}>{item.title}</p>
                                    <ul key={index}>
                                        {item.desc.map((itemDesc, indexDesc) => (
                                            <li key={indexDesc}>
                                                {itemDesc}
                                            </li>
                                        ))}
                                    </ul></>
                            ))}
                        </li>
                    </ol>
                </div>
            </section>
        </ClientLayout>
    )
}

export const getStaticProps = async (ctx) => {
    const { locale } = ctx
    const meta = {
        title: textConfig[locale]?.title_how_to_booking,
        keywords: textConfig[locale]?.text_keyword,
        description: 'Luxury29 Car Rental How To Booking Page',
        image: 'main-pic.jpeg'
    };

    return {
        props: { meta },
    };
};


export default MetaHeader(HowToBooking);